import React, { useState } from 'react'
import { NavLink } from 'react-router-dom';

const Footer = () => {
    const [email, setEmail] = useState('');
    const handleSend = () => {
        console.log('Email submitted:', email);
        // You can add API calls or validations here
    };
    return (
        <>
            <div className='footer-mainsection'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-3'>
                            <div className='footer-sec1'>
                                <NavLink style={{ textDecoration: 'none' }} to={'/'}>
                                    <div className='footer-sec1box'>
                                        <img className='footerlogo' src='../assets/images/Logo.webp' alt='footer Logo' />
                                        {/* <h3 className='footerlogo-text'>4SIGHT TECH</h3> */}
                                    </div>
                                </NavLink>
                                <img className='footermap' src='../assets/images/footermap.png' alt='footer Logo' />
                                <p className='footelogo-subtxt'>At 4Sight Tech Solutions, we provide IT solutions for global businesses</p>
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className='footer-section2'>
                                <h3 className='footer-subhead'>Page Links</h3>
                                <ul className='footer-listsec'>
                                    <li><NavLink className="footerlinks" onClick={(e) => {
                                        e.stopPropagation();
                                        window.scrollTo(0, 0);
                                    }} to={'/About-Us'}>About Us</NavLink></li>
                                    <li><NavLink className="footerlinks" onClick={(e) => {
                                        e.stopPropagation();
                                        window.scrollTo(0, 0);
                                    }} to={'/Service'}>Service</NavLink></li>
                                    <li><NavLink className="footerlinks" onClick={(e) => {
                                        e.stopPropagation();
                                        window.scrollTo(0, 0);
                                    }} to={'/Careers'}>Careers</NavLink></li>
                                    <li><NavLink className="footerlinks" onClick={(e) => {
                                        e.stopPropagation();
                                        window.scrollTo(0, 0);
                                    }} to={'/Blog'}>Our Blog</NavLink></li>
                                    <li><NavLink className="footerlinks" onClick={(e) => {
                                        e.stopPropagation();
                                        window.scrollTo(0, 0);
                                    }} to={'/Contact-Us'}>Contact us</NavLink></li>
                                </ul>
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className='footer-section3'>
                                <h3 className='footer-subhead'>Contacts</h3>
                                <div className='footer-section3-box'>
                                    <img className='section3-boxim' src='../assets/images/icons/icon_address.png' alt='location' />
                                    {/* <p className='section3-boxtxt'>10713 N MacArthur Blvd, Irving, TX – 75063</p> */}
                                    <p className='section3-boxtxt'>4099 McEwen Rd. Suite 504 Dallas, TX 75244.</p>
                                </div>
                                <div className='footer-section3-box'>
                                    <img className='section3-boxim section3-boxim2' src='../assets/images/icons/icon22.png' alt='location' />
                                    <p className='section3-boxtxt'>Mon-Sat 9:00 - 7:00</p>
                                </div>
                                <div className='footer-section3-box'>
                                    <img className='section3-boxim section3-boxim2' src='../assets/images/icons/icon33.png' alt='location' />
                                    <p className='section3-boxtxt'>+1 945-419-8003</p>
                                </div>
                                <div className='footer-section3-box section3-boxim2'>
                                    <img className='section3-boxim' src='../assets/images/icons/icon44.png' alt='location' />
                                    <p className='section3-boxtxt'>hr@4sightek.com</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className='footer-section4'>
                                <h3 className='footer-subhead'>Have a project in mind?</h3>
                                <p className='footertxt2'>Get exclusive news & offers through our 4Sight Tech newsletter</p>
                                <div className='footer-newslettersec'>
                                    <input
                                        type="email"
                                        placeholder="Your email address"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        className="footerin"
                                    />
                                    <button className='submitbt' onClick={handleSend}> <img className='' src='../assets/images/icons/Symbol.png' alt='send icon' /> </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='footersec2'>
                        <div className='footersec-last'>
                            <p className='copyrighttxt'>Copyright © 2025 4Sight Tech | All Right Reserved</p>
                            <div className='socialicons-section'>
                                <button className='social-icon'>
                                    <img className='symbol1-im' src='../assets/images/icons/Symbol1.png' alt='social icon' />
                                    <div className='test-sec'></div>
                                </button>
                                <button className='social-icon'>
                                    <img className='symbol2-im' src='../assets/images/icons/Symbol2.png' alt='social icon' />
                                    <div className='test-sec'></div>
                                </button>
                                <button className='social-icon'>
                                    <img className='symbol3-im' src='../assets/images/icons/Symbol3.png' alt='social icon' />
                                    <div className='test-sec'></div>
                                </button>
                                <button className='social-icon'>
                                    <img className='symbol4-im' src='../assets/images/icons/Symbol4.png' alt='social icon' />
                                    <div className='test-sec'></div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Footer;